import { createFileRoute, notFound } from "@tanstack/react-router";

import { AboutView } from "@/components/pages/AboutView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/about")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/about",
          ...meta[params.locale].about,
        })
      : {},
  component: AboutRoute,
});

function AboutRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <AboutView locale={locale} />;
}
